import { render } from "./SucursalesList.vue?vue&type=template&id=22671917&scoped=true"
import script from "./SucursalesList.vue?vue&type=script&lang=js"
export * from "./SucursalesList.vue?vue&type=script&lang=js"

import "./SucursalesList.vue?vue&type=style&index=0&id=22671917&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22671917"]])

export default __exports__